<script lang="ts">
export default {
  name: 'PoliciesCollapseView',
};
</script>

<script setup lang="ts">
import { RuleViolatingPolicy } from '@/services/v2/ClientReadinessService';
import { EllipsisVertical } from 'lucide-vue-next';

defineProps<{
  title: string;
  policies: RuleViolatingPolicy[];
}>();

const emit = defineEmits<{
  editPolicy: [policyId: number, mainPolicyNumber: string];
}>();
</script>

<template>
  <div
    class="tw:collapse-arrow tw:collapse tw:overflow-visible tw:rounded-lg tw:bg-base-200 tw:text-lg"
    :class="{ 'tw:collapse-close': policies.length === 0 }">
    <input type="checkbox" />
    <div class="tw:collapse-title tw:flex tw:justify-between">
      <div>{{ title }}</div>
      <div class="tw:text-xl" :class="{ 'tw:text-primary': policies.length > 0 }">
        {{ policies.length }}
      </div>
    </div>
    <div class="tw:collapse-content">
      <table class="tw:table tw:bg-white">
        <tbody>
          <tr v-for="policy in policies" :key="policy.policyId">
            <td>
              <div class="tw:flex tw:items-center tw:gap-2">
                <div class="tw:text-base">
                  {{ policy.description }}
                </div>
                <div class="tw:text-xs">({{ policy.mainPolicyNumber }})</div>
              </div>
            </td>
            <td class="tw:text-end">
              <div class="tw:dropdown">
                <div tabindex="0" role="button" class="tw:btn tw:btn-xs">
                  <EllipsisVertical :size="15" />
                </div>
                <ul tabindex="0" class="tw:dropdown-content tw:menu tw:menu-xs tw:rounded-lg tw:bg-white tw:shadow">
                  <li>
                    <a
                      class="tw:whitespace-nowrap"
                      @click="emit('editPolicy', policy.policyId, policy.mainPolicyNumber)"
                      >Edit Policy</a
                    >
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
